import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { listOfCountries } from '../../constants/listOfCountries';
import { Controller, Control } from 'react-hook-form';
import { SignUpFormType } from '../../types/types';
import { PT, fieldSx } from '../portalUi';

interface CountrySelectProps {
  control: Control<SignUpFormType, SignUpFormType>;
  onCountryChange: (areaCode: string) => void;  // Add callback for area code
}

const CountrySelect = ({ control, onCountryChange }: CountrySelectProps) => {
  return (
    <Controller
      name="country"
      control={control}
      rules={{
        required: true
      }}
      render={({ field: { onChange, value } }) => (
        <Autocomplete
          id="country-select-demo"
          sx={{ width: 'auto', marginTop: '16px', marginBottom: '8px' }}
          options={listOfCountries}
          autoHighlight
          slotProps={{
            paper: {
              sx: {
                bgcolor: PT.surface,
                backgroundImage: 'none',
                color: PT.text,
                border: `1px solid ${PT.borderStrong}`,
                borderRadius: '10px',
                boxShadow: '0 20px 60px rgba(0,0,0,0.55)',
                '& .MuiAutocomplete-option': {
                  '&:hover, &.Mui-focused': {
                    backgroundColor: 'rgba(56,232,255,0.10)'
                  },
                  '&[aria-selected="true"]': {
                    backgroundColor: 'rgba(56,232,255,0.16)'
                  }
                }
              }
            }
          }}
          getOptionLabel={(option) => option.label}
          renderOption={(props, option) => (
            <Box
              component="li"
              sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
              {...props}
            >
              <img
                loading="lazy"
                width="20"
                srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                alt=""
              />
              {option.label} ({option.code})
            </Box>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Choose a country"
              sx={fieldSx}
              inputProps={{
                ...params.inputProps
              }}
              required
            />
          )}
          onChange={(_, item) => {
            onChange(item);
            onCountryChange(item ? item.phone : ''); // Pass area code to parent
          }}
          value={value}
        />
      )}
    />
  );
};

export default CountrySelect;
